const DEFAULT_DURATION = 600;

const EASINGS = {
  linear: (t) => t,
  easeInOutQuad: (t) => (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t),
  easeOutCubic: (t) => (--t) * t * t + 1,
  easeOutExpo: (t) => (t === 1 ? 1 : 1 - Math.pow(2, -10 * t)),
  easeOutSine: (t) => Math.sin((t * Math.PI) / 2),
};

export function scrollTo(target, options = {}) {
  if (target === undefined || target === null) return;

  const {
    duration = DEFAULT_DURATION,
    offset = 0,
    easing = "easeInOutQuad",
    complete,
  } = options;
  const easingFn = typeof easing === "function" ? easing : EASINGS[easing] || EASINGS.easeInOutQuad;

  const startY = Math.round(window.pageYOffset || document.documentElement.scrollTop || 0);
  const targetY = typeof target === "number" ? Math.round(target) : getElementY(target);
  const destination = Math.round(targetY + offset);
  const distance = destination - startY;

  if (duration <= 0 || Math.abs(distance) < 1) {
    window.scrollTo(0, destination);
    if (typeof complete === "function") complete();
    return;
  }

  const startTime = performance.now();

  function step(currentTime) {
    const elapsed = Math.min((currentTime - startTime) / duration, 1);
    const eased = easingFn(elapsed);
    const nextY = Math.round(startY + distance * eased);

    window.scrollTo(0, nextY);

    if (elapsed < 1) {
      window.requestAnimationFrame(step);
    } else if (typeof complete === "function") {
      complete();
    }
  }

  window.requestAnimationFrame(step);
}

export function scrollToTop(options = {}) {
  scrollTo(0, options);
}

function getElementY(element) {
  if (!(element instanceof Element)) return 0;
  const rect = element.getBoundingClientRect();
  const base = window.pageYOffset || document.documentElement.scrollTop || 0;
  return Math.round(rect.top + base);
}
